import React from 'react';
import { Card, CardActions, CardContent, Typography, ButtonBase } from '@material-ui/core';
import { useStyles } from './OptionCardStyle';
import ArrowIMG from '../../assets/arrowButton.png';


interface TextOptionCardProps {
    title: string;
    subTitle: string;
}

export default function OptionCard(props: TextOptionCardProps) {

    const classes = useStyles();

    return (
        <ButtonBase className={classes.button}>
            <Card className={classes.root} variant='outlined'>
                <CardContent>
                    <Typography className={classes.title} gutterBottom>
                        {props.title}
                    </Typography>
                    <Typography className={classes.subTitle}>
                        {props.subTitle}
                    </Typography>
                </CardContent>
                <CardActions>
                    <img src={ArrowIMG} alt="Ícone ilustrativo" className={classes.image} />
                </CardActions>
            </Card>
        </ButtonBase>
    )
}